import Layout from '@/views/main/Main.vue'
import type { RouteRecordRaw } from "vue-router";
const systemRouter: RouteRecordRaw = {
    path: '/system',
    component: Layout,
    redirect: 'noredirect',
    meta: {
        icon: 'el-icon-user-solid',
        title: '系统管理'
    },
    children: [
        {
            path: '/system/organization',
            component: () => import("@/views/main/system/organization/organization.vue"),
            name: 'organization',
            meta: {
                title: '部门管理'
            }
        },
        {
            path: '/system/position',
            component: () => import("@/views/main/system/position/position.vue"),
            name: 'position',
            meta: {
                title: '职位管理'
            }
        },
        {
            path: '/system/user',
            component: () => import("@/views/main/system/user/user.vue"),
            name: 'user',
            meta: {
                title: '用户管理'
            }
        },
        {
            path: '/system/role',
            component: () => import("@/views/main/system/role/role.vue"),
            name: 'role',
            meta: {
                title: '角色管理'
            }
        },



        {
            path: "/system/file",
            component: () => import("@/views/main/system/file/file.vue"),
            name: 'file',
            meta: {
                title: '文件管理'
            }
        },
        {
            path: "/system/dictionaries",
            component: () => import("@/views/main/system/dictionaries/dictionaries.vue"),
            name: 'dictionaries',
            meta: {
                title: '字典管理'
            }
        },
        {
            path: "/system/setting",
            component: () => import("@/views/main/system/setting/setting.vue"),
            name: 'setting',
            meta: {
                title: '系统配置'
            }
        }
    ]
}

//系统管理路由
export default systemRouter